import { rgba } from 'polished';

/** Recommendation: If using VS Code, install 'Color Highlight' extention to see colour shades directly in the editor */

export const palette = {
    graphite: {
        white: '#FFFFFF',
        cloud: '#F7F7F7',
        gray: '#F0EFEF',
        pearl: '#F6FBF9',
        silver: '#EFEFEF',
        ash: '#A5A5A5',
        charcoal: '#777877',
        heavyMetal: '#3B3C3B',
        onyx: '#1D1E1D',
    },

    evergreen: {
        mintLight: '#E9F6F0',
        mint: '#DEF1E9',
        lime: '#8CBD00',
        aspargusLight: '#36AB7A',
        aspargus: '#20A26B',
    },

    vibrant: {
        yellow: '#FFD860',
        gold: '#FCBE00',
        orange: '#FF8540',
        coral: '#C95020',
        red: '#EB5757',
        raspberry: '#CC213D',
        blue: '#3646D9',
    },

    pastel: {
        red: '#FDF2F2',
        orange: '#FFF5F0',
        yellow: '#FFF8E5',
        lime: '#F6FAEB',
        aspargus: '#EDF8F3',
    },

    lightroom: {
        whiteLight: rgba(255, 255, 255, 0.8),
        cloudLight: rgba(247, 247, 247, 0.5),
        goldLight: rgba(252, 190, 0, 0.8),
        goldLightHigh: rgba(252, 190, 0, 0.1),
        redLight: rgba(235, 87, 87, 0.8),
        redLightHigh: rgba(235, 87, 87, 0.1),
        aspargusLight: rgba(32, 162, 107, 0.8),
        aspargusLightHigh: rgba(32, 162, 107, 0.1),
        heavyMetalLight: rgba(59, 60, 59, 0.8),
        heavyMetalLightHigh: rgba(59, 60, 59, 0.1),
        heavyMetalLightUltra: rgba(59, 60, 59, 0.05),
        blackLight: rgba(0, 0, 0, 0.8),
    },
};
